module.exports = __webpack_public_path__ + "img/my.09619b9f.svg";